var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":_vm.size,"height":_vm.size,"viewBox":"0 0 100 100"}},[_c('path',{attrs:{"fill":"none","d":" M 95  5 L 10 50 L 95 95","stroke":_vm.color,"stroke-width":"7px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }